<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ng-container [ngSwitch]="forcedUrl">
        <ion-back-button
          icon="chevron-back"
          *ngSwitchCase="''"
          defaultHref="tabs/jobs"
        ></ion-back-button>
        <ion-back-button
          icon="chevron-back"
          *ngSwitchDefault
          defaultHref="tabs/jobs"
          [routerLink]="forcedUrl"
        ></ion-back-button>
      </ng-container>
    </ion-buttons>
    <ion-title>Last Minute job</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="job">
  <mable-heading heading="h3">{{job?.title}}</mable-heading>

  <div class="notification ion-margin-horizontal">
    <ion-icon name="checkmark-circle"></ion-icon>
    <div class="message">
      <p>{{job?.clientFields?.acceptedMatch?.user?.truncatedName}} has been booked for your job</p>
    </div>
  </div>

  <mable-heading heading="h3">Your support worker</mable-heading>
  <app-worker-bid
    [bid]="job?.clientFields?.acceptedMatch"
    [noMsg]="false"
    [channelUrl]="job?.workerFields?.conversation?.sendbirdChannelDetail?.channelUrl"
  >
  </app-worker-bid>

  <mable-heading heading="h3">Job Description</mable-heading>

  <app-flex-job-summary
    [job]="job"
    bgColor="white-0"
  ></app-flex-job-summary>
</ion-content>
